import {
  GetForms_vm_forms as FormType,
  GetForms_vm_forms_formItems_VOLUNTEER_FormItemFieldType_field as FormItemField,
} from '../__generated__/GetForms';
import {
  GetFormSubmissionsList,
  GetFormSubmissionsListVariables,
  GetFormSubmissionsList_vm_form_formSubmissions as FormSubmissionListItem,
  GetFormSubmissionsList_vm_form_formSubmissions_formFieldValues as FormFieldValue,
  GetFormSubmissionsList_vm_form_formItems_VOLUNTEER_FormItemFieldType as FormItemFieldType,
} from '../__generated__/GetFormSubmissionsList';
import {
  GetFormSubmission,
  GetFormSubmissionVariables,
  GetFormSubmission_vm_form_formSubmission as FormSubmissionDetail,
  GetFormSubmission_vm_form_formSubmission_formFieldValues as FormSubmissionFieldValue,
  GetFormSubmission_vm_form_formSubmission_comments as FormSubmissionComment,
  GetFormSubmission_vm_form_formSubmission_creations as FormSubmissionCreation,
} from '../__generated__/GetFormSubmission';
import {
  CreateRosterTemplateScreenGetProgramsAndActivities,
  CreateRosterTemplateScreenGetProgramsAndActivities_vm_programs as FormWizardProgram,
  CreateRosterTemplateScreenGetProgramsAndActivities_vm_activities as FormWizardActivity,
} from '../../../program-manager/rosters/roster-templates-screen/__generated__/CreateRosterTemplateScreenGetProgramsAndActivities';

// Re-export generated types
export type {
  FormType,
  FormSubmissionListItem,
  FormSubmissionDetail,
  FormFieldValue,
  FormSubmissionFieldValue,
  FormSubmissionComment,
  FormSubmissionCreation,
  FormItemFieldType,
  FormItemField,
  FormWizardProgram,
  FormWizardActivity,
  GetFormSubmissionsList,
  GetFormSubmissionsListVariables,
  GetFormSubmission,
  GetFormSubmissionVariables,
  CreateRosterTemplateScreenGetProgramsAndActivities,
};

// Derived types used across components
export interface FormFieldConfig {
  taskFieldId: string;
  name: string;
  fieldType: string;
  minValue?: number;
  maxValue?: number;
  minLabel?: string;
  maxLabel?: string;
}

export interface AvailableFormField {
  taskFieldId: string;
  name: string;
}

export interface ChartDataPoint {
  date: string;
  responses: number;
}

export interface ChoiceDataItem {
  name: string;
  fullName: string;
  count: number;
  percentage: number;
}

export interface NumericDataItem {
  name: string;
  count: number;
}

export interface TextItem {
  id: string;
  value: string;
}

// FieldAnalytics discriminated union
interface BaseFieldAnalytics {
  taskFieldId: string;
  name: string;
  fieldType: string;
  totalResponses: number;
  answeredCount: number;
  config?: Record<string, any>;
}

export interface ChoiceFieldAnalytics extends BaseFieldAnalytics {
  type: 'choice';
  data: ChoiceDataItem[];
}

export interface NumericFieldAnalytics extends BaseFieldAnalytics {
  type: 'numeric';
  avg: string;
  data: NumericDataItem[];
  scaleMin: number;
  scaleMax: number;
}

export interface TextFieldAnalytics extends BaseFieldAnalytics {
  type: 'text';
  items: TextItem[];
}

export interface ListFieldAnalytics extends BaseFieldAnalytics {
  type: 'list';
  items: TextItem[];
}

export interface SignatureFieldAnalytics extends BaseFieldAnalytics {
  type: 'signature';
}

export interface MatrixFieldAnalytics extends BaseFieldAnalytics {
  type: 'matrix';
  items: TextItem[];
}

export interface UnknownFieldAnalytics extends BaseFieldAnalytics {
  type: 'unknown';
  values: string[];
}

export type FieldAnalytics =
  | ChoiceFieldAnalytics
  | NumericFieldAnalytics
  | TextFieldAnalytics
  | ListFieldAnalytics
  | SignatureFieldAnalytics
  | MatrixFieldAnalytics
  | UnknownFieldAnalytics;

export type SortOrder = 'newest' | 'oldest';
export type EntityType = 'activity' | 'roster_template';

export const PAGE_SIZE = 25;
